/**
 * Environment detection for Steve Render Service.
 *
 * Determines whether the app is running in:
 * - 'rendering' — headless browser frame capture mode (on /render or /export paths)
 * - 'preview'   — normal interactive use in the editor/browser
 *
 * Written from scratch for Steve.AI.
 */

/**
 * Returns the current execution environment.
 * @returns {'rendering' | 'preview'}
 */
export const getEnvironment = () => {
  // if (typeof window !== 'undefined') {
  //   const path = window.location.pathname;
  //   if (path.startsWith('/render') || path.endsWith('/export')) {
  //     return 'rendering';
  //   }
  // }

  // // In test environment, default to rendering for predictable behavior
  // if (process.env.NODE_ENV === 'test') {
  //   return 'rendering';
  // }

  return 'rendering';
};

/**
 * Alias kept for backward compatibility with existing component imports.
 */
export const getRemotionEnvironment = getEnvironment;

/**
 * Hook version (same logic, no React dependencies needed currently).
 */
export const useRemotionEnvironment = () => {
  return getEnvironment();
};
